/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 document.addEventListener("DOMContentLoaded", function () {

  let product_slider = new Splide( '#splide-product', { 
    type   : 'slide', 
    pagination  : true,
    arrows: true, 
    width: '100vw',
    perPage: 1,
    pauseOnHover: false, 
    isNavigation: true, 
    lazyLoad: true
  }); 

  product_slider.mount();

});


 function addItemToCartt(variant_id, qty ) {

  data = {
    id: variant_id,
    quantity: qty
  }; 

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    },
  });

  setTimeout(() => {
    document.getElementById("sidebar-cart").setAttribute("aria-hidden", "false");
    document.getElementById("PageOverlay").classList.add('is-visible');
  }, 100);
}

function closeCartDrawer() {
  document.getElementById("sidebar-cart").setAttribute("aria-hidden", "true");
  document.getElementById("PageOverlay").classList.remove('is-visible');
};



function addCartItemToCart(variant_id, qty ) {
  data = {
    id: variant_id,
    quantity: qty
  }; 

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    },
  });

  setTimeout(() => {
    document.getElementById("sidebar-cart").setAttribute("aria-hidden", "false");
    document.getElementById("PageOverlay").classList.add('is-visible');
    jQuery(".related-div").hide(); 
        
    if(jQuery(".cre_item").text()){
      jQuery(".related-div").show();
    }
    

  }, 1000);
}



 const announcement = document.querySelector('#section-announcement');
 const socialSlider = document.querySelector('.social_slider_section');
 const logoSlider = document.querySelector('#logo_slider');
 const imageSlider = document.querySelector('#image-carousel');
 const itemSlider = document.querySelector('#item_slider');


  /* Announcmentbar */
  if (announcement) {
    let announcement = new Splide( '#announcment_slider', {  
      type   : 'loop', 
      pagination  : false,
      arrows: false,
      perPage: 1,
      pauseOnHover: false,
      focus: 'center',
      isNavigation: false,  
      drag: 'false',
      lazyLoad: true,
      autoplay: true, 
      breakpoints: {
        640: {
          perPage: 1,
          autoplay: false,
        },
      }
    });
    
    announcement.mount();
  }

  if (socialSlider) {

    let social_slider = new Splide( '#social_slider', {  
      type   : 'loop', 
      pagination  : false,
      arrows: true, 
      pauseOnHover: false,
      focus: 'center',
      isNavigation: false, 
      gap: 20,  
      drag: 'free',
      fixedWidth: 400,
      lazyLoad: true,
      autoplay: false,
      breakpoints: {
        640: {
          fixedWidth: 300,
          gap: 15
        },
      } 
    }); 

    social_slider.mount(window.splide.Extensions);
  }
  // social_slider.mount(window.splide.Extensions);

  if (logoSlider) {

    let logo_slider = new Splide( '#logo_slider', {  
      type   : 'loop', 
      pagination  : false,
      arrows: false, 
      pauseOnHover: false,
      isNavigation: false, 
      gap: 0,  
      drag: 'free',
      autoWidth: true,
      lazyLoad: true,
      autoplay: true
      
    }); 

    logo_slider.mount();
  }

  if (imageSlider) {

    let image_slider = new Splide( '#image-carousel', {  
      type   : 'loop', 
      pagination  : true,
      arrows: true, 
      isNavigation: false, 
      gap: 0,  
      perPage: 1,
      autoWidth: true, 
      lazyLoad: true,
      pauseOnHover: false,
      autoplay: true
    }); 

    image_slider.mount();
  }

  if (itemSlider) {

    let item_slider = new Splide( '#item_slider', {  
      type   : 'loop', 
      pagination  : false,
      arrows: true, 
      perPage: 3,
      pauseOnHover: false,
      focus: 'center',
      isNavigation: false, 
      gap: 20,  
      drag: 'free',
      lazyLoad: true,
      autoplay: true, 
      breakpoints: {
        640: {
          perPage: 1
        },
      } 
    }); 

    item_slider.mount();
  }



  document.addEventListener("DOMContentLoaded", function () {

  
    let addToCartBtn = document.querySelector('.ProductForm__AddToCart');

    if(addToCartBtn)  {
      addToCartBtn.onclick = () => fetchReleatedItems();
    }

    let body = document.querySelector('body');
    body.addEventListener('click', function(e) {

      if( e.target.classList.contains('ButtonGroup__Item') ) {
        fetchReleatedItems();
      }

    });

  });

  
  function fetchReleatedItems() {
    // settimeout
    setTimeout(() => {
      fetch('cart?section_id=mini-cart&yeet').then(function (response) {
        // The API call was successful!
        return response.text();
      }).then(function (html) {
        // This is the HTML from our response as a text string
        let releatedProducts = document.querySelector('.related-div');
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, "text/html");

        let docArticle = doc.querySelector('.related-div');

        // replace related products with docArticle
        if (releatedProducts) {
          releatedProducts.replaceWith(docArticle);
        }

      }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });
    }, 500);
  }
 

  
  document.addEventListener("DOMContentLoaded", function () {
    
    gaspLoaded = false;

    function callGsap() {
        // Check if gasp i loaded.
        if (gaspLoaded) {
            return;
            gsap.registerPlugin(ScrollTrigger);
        }
        // If not loaded, set a check to know for further calls.
        gaspLoaded = true;  
    }

  });






// const frontpage = document.querySelector('.template-index');
const linkPath = window.location.pathname;


  document.addEventListener("DOMContentLoaded", function () {
    const config = {
      denmark: {
        url: 'https://dk.allmatters.com'+linkPath,
        icon: '🇩🇰',
        prettyName: 'Danmark',
        countryCode: 'DK'
      },
      netherlands: {
        url: 'https://nl.allmatters.com'+linkPath,
        icon: '🇳🇱',
        prettyName: 'Nederland',
        countryCode: 'DK'
      },
      spain: {
        url: 'https://allmatters.es'+linkPath,
        icon: '🇪🇸',
        prettyName: 'España',
        countryCode: 'ES'
      },
      italy: {
        url: 'https://it.allmatters.com'+linkPath,
        icon: '🇮🇹',
        prettyName: 'Italia',
        countryCode: 'IT' 
      },
      global: {
        url: 'https://allmatters.com/en-eu'+linkPath,
        prettyName: 'Europe',
        icon: '🇪🇺'
      },
    }
  
    // const globalRedirect = async () => {
    //   // Get detected country from user based on IP.
    //   const { detected_values: detectedCountry } = await fetch('/browsing_context_suggestions.json').then(r => r.json());
    //   const shops = Object.entries(config);
  
    //   const recommendedStore = shops.find(([key, {countryCode}]) => countryCode === detectedCountry.country.handle) || shops.find(([key]) => key === 'global');
  
    //   let windowUrl = window.location.href;
    //   // remove everything after ? in url
    //   windowUrl = windowUrl.split('?')[0];
    //   // Hvis man ikke er på det det samme url som recommended, så kører popuppen.
    //   if(recommendedStore[1].url === windowUrl) return;
  
    //   // Open popup, to ask user if they're on the correct shop or not.
    //   const geopopup = document.querySelector('.geo-popup');
    //   const geoContainer = document.querySelector('.geo-popup .container');
    //   const yourlocation = document.querySelector('#your-location');
    //   const yourlocationlabel = document.querySelector('#your-lang--label');
    //   const yourLangIcon = document.querySelector('#your-lang--Icon');
    //   const closeBtn = document.querySelector('.close-btn'); 
    //   const backDrop = document.querySelector('.geo-backdrop');
      
    //   // activate popup and disable scroll
    //   geopopup.classList.add('geo--active');
    //   document.body.style.overflow = 'hidden';
  
    //   // Set correct url on link.
    //   yourlocation.setAttribute('href', recommendedStore[1].url);
    //   yourlocationlabel.innerHTML = recommendedStore[1].prettyName;
    //   yourLangIcon.innerHTML = recommendedStore[1].icon;
  
    //   // Vi sætter en onclick, på hele popuppen, så når man vælger hvilken side man gerne vil til
    //   // så sætter den en cookie, og lukker popuppen. 
    //   closeBtn.addEventListener('click', function(e) {
    //     var d = new Date();
    //     d.setTime(d.getTime() + (5*24*60*60*1000));
    //     var expires = "expires="+ d.toUTCString();
    //     document.cookie = "geoIgnore=true;" + expires + ";path=/";
  
    //     geopopup.classList.remove('geo--active');
        
    //   });
  
    //   backDrop.addEventListener('click', function(e) {
    //     var d = new Date();
    //     d.setTime(d.getTime() + (5*24*60*60*1000));
    //     var expires = "expires="+ d.toUTCString();
    //     document.cookie = "geoIgnore=true;" + expires + ";path=/";
  
    //     geopopup.classList.remove('geo--active');
    //   }); 
      
      
  
    //   geoContainer.addEventListener('click', function(e) {
    //     // set cookie as geoIgnore=true for 5 days
    //     var d = new Date();
    //     d.setTime(d.getTime() + (5*24*60*60*1000));
    //     var expires = "expires="+ d.toUTCString();
    //     document.cookie = "geoIgnore=true;" + expires + ";path=/";
  
    //     // close popup and enable scroll
    
    //     document.body.style.overflow = 'auto';
    //   });
    // }
  
    // if cookie geoIgnore is not set, run geoRedirect
    if (document.cookie.indexOf('geoIgnore') === -1) {
      globalRedirect();
    }
  
    // set a new variable
    
    
    // force remove cookie geoIgnore
  
  
  
  });



document.addEventListener("DOMContentLoaded", function () {
jQuery('.lang-menu-link').each(function(){  
  let langItems = ['en-eu', 'en-no', 'en-se', 'en-gb', 'en-us', 'en-ca', 'en-mx'];  
  

  // if linkPath is in langItems dont add it
  let newLinkPath = linkPath;

  let itemHit = langItems.find(item => newLinkPath.includes(item));
  if(itemHit) {
    newLinkPath = newLinkPath.replace(itemHit, '');
  }
  
  

  let newLink = this.href + newLinkPath;



  newLink = newLink.replace(/([^:]\/)\/+/g, "$1");

  this.href = newLink;
  })
});




let valueList = document.querySelector('.Popover__ValueList'); // Gets the list of elements 

let activeOption1 = valueList.childNodes[0].children[1].innerHTML; // Gets the meta text for option 1
let activeOption2 = valueList.childNodes[1].children[1].innerHTML; // Gets the meta text for option 2
let activeOption3 = valueList.childNodes[2].children[1].innerHTML; // Gets the meta text for option 3
let activeMeta = document.getElementById('activeMeta');

document.addEventListener('variant:changed', function(event) {
   let variant = event.detail.variant; // Gives you access to the whole variant details
   let activeVariant = variant.title;  // active variant option 

   if (variant.title == 'A') {
    activeMeta.innerHTML = activeOption1;

   } else if (variant.title == 'B') {
    activeMeta.innerHTML = activeOption2;

   }  else if (variant.title == 'Mini') {
      activeMeta.innerHTML = activeOption3;
   }

});
